import styled from 'styled-components';

const StyledHowItWorks = styled.div`
  position: relative;
  width: 100%;
  background-color: #EFEFEF;
  text-align: center;
  overflow: hidden;
  .how-it-work-bg {
    position: relative;
    padding: 10px;
    height: 210px;
    text-align: center;
    .main-img {
      position: absolute;
      top: 0;
      left: 0;
      height: 210px;
    }
    .main-icon {
      position: relative;
      height: 110px;
      z-index: 1;
    }
    .title {
      position: relative;
      padding: 0;
      padding-top: ${props => (!props.isMobile ? 10 : 0)}px;
      margin-bottom: ${props => (!props.isMobile ? 25 : 23)}px;
      text-align: center;
      font-size: ${props => (!props.isMobile ? 30 : 24)}px;
      font-weight: 500;
      line-height: 1.2;
      color: #fff;
    }
  }
  .action-close,
  .action-back {
    position: absolute;
    padding: 0;
    top: 10px;
    width: 18px;
    height: 18px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    &:focus {
      outline: none;
    }
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
  .action-back {
    left: 10px;
  }
  .action-close {
    right: 10px;
    width: 16px;
    height: 16px;
  }
  .help-content {
    position: relative;
    margin: 0;
    padding: 15px 15px 0 25px;
    list-style: none;
    
    li {
      position: relative;
      margin-bottom: 10px;
      font-size: 14px;
      line-height: 18px;
      text-align: left;
      letter-spacing: 0;
      color: #555;
      
      &:before {
        content: '';
        position: absolute;
        top: 7px;
        width: 5px;
        height: 5px;
        left: -10px;
        border-radius: 50%;
        background-color: #555555;
      }
      
      strong {
        font-weight: 500;
      }
    }
  }
  .share-with-care {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    color: #555555;
  }
`;

export default StyledHowItWorks;
